export const reciboCabecalhos = {
   VO699: {
      spe1: {
         razaoSocial: 'SPE JFL VO699 EMPREENDIMENTO IMOBILIÁRIO S.A.',
         cabecalho: ', sociedade anônima, inscrita no CNPJ sob nº 30.628.332/0001-86, com sede na Avenida Rebouças, nº 3.084, 4° andar, parte, Pinheiros, São Paulo - SP, CEP 05402-600, declara receber de: '
      }
   },
   JFL125: {
      spe1: {
         razaoSocial: 'SPE JFL125 EMPREENDIMENTO IMOBILIÁRIO S.A.',
         cabecalho: ', sociedade anônima, com sede na Avenida Rebouças, nº 3.084, 4° andar, parte, Pinheiros, São Paulo - SP, CEP 05402-600, na cidade de São Paulo, estado de São Paulo, inscrita no Cadastro Nacional da Pessoa Jurídica do Ministério da Economia (“CNPJ”) sob o nº 18.704.442/0001-84, neste ato representada pela JFL FARIA LIMA ADMINISTRADORA IMOBILIÁRIA LTDA., sociedade empresária limitada, com sede na cidade de São Paulo, estado de São Paulo, na Avenida Rebouças, nº 3.084, 4° andar, parte, Pinheiros, São Paulo - SP, CEP 05402-600, inscrita no CNPJ sob o nº 47.427.424/0001-09, declara receber de:'
      },
      spe2: {
         razaoSocial: 'SPE II JFL 125 EMPREENDIMENTO IMOBILIARIO S.A.',
         cabecalho: ', sociedade anônima, inscrita no CNPJ sob o nº 51.888.921/0001-73, neste ato representado pela JFL FARIA LIMA ADMINISTRADORA IMOBILIÁRIA LTDA., sociedade empresária limitada, com sede na cidade de São Paulo, estado de São Paulo, na Avenida Rebouças, nº 3.084, 4° andar, parte, Pinheiros, São Paulo - SP, CEP 05402-600, inscrita no CNPJ sob o nº 47.427.424/0001-09, declara receber de:'
      }
   },
   JML747: {
      spe1: {
         razaoSocial: 'SPE JFL JML747 EMPREENDIMENTO IMOBILIÁRIO S.A.',
         cabecalho: ', sociedade anônima, com sede na Avenida Rebouças, nº 3.084, 4° andar, parte, Pinheiros, São Paulo - SP, CEP 05402-600, na cidade de São Paulo, estado de São Paulo, inscrita no Cadastro Nacional da Pessoa Jurídica do Ministério da Economia (“CNPJ”) sob o nº 34.100.091/0001-59, neste ato representada pela JFL ADMINISTRADORA IMOBILIÁRIA – JML LTDA., sociedade empresária limitada, com sede na cidade de São Paulo, estado de São Paulo, na Avenida Rebouças, nº 3.084, 4° andar, parte, Pinheiros, São Paulo - SP, CEP 05402-600, inscrita no CNPJ sob o nº 43.883.992/0001-55, declara receber de:'
      },
      spe2: {
         razaoSocial: 'SPE II JFL JML747 EMPREENDIMENTO IMOBILIARIO S.A.',
         cabecalho: ', sociedade anônima, inscrita no CNPJ sob o nº 51.920.614/0001-22, neste ato representado pela JFL ADMINISTRADORA IMOBILIÁRIA – JML LTDA., sociedade empresária limitada, com sede na cidade de São Paulo, estado de São Paulo, na Avenida Rebouças, nº 3.084, 4° andar, parte, Pinheiros, São Paulo - SP, CEP 05402-600, inscrita no CNPJ sob o nº 43.883.992/0001-55, declara receber de:'
      }
   },
   AVNU: {
      spe1: {
         razaoSocial: 'SPE JFL AVNU EMPREENDIMENTO IMOBILIARIO S.A.',
         cabecalho: ', sociedade anônima, com sede na Avenida Rebouças, nº 3.084, 4° andar, parte, Pinheiros, São Paulo - SP, CEP 05402-600, na cidade de São Paulo, estado de São Paulo, inscrita no Cadastro Nacional da Pessoa Jurídica do Ministério da Economia (“CNPJ”) sob o nº 35.946.965/0001-56, declara receber de:'
      }
   },
   VHOUSE: {
      spe1: {
         razaoSocial: 'SPE JFL VHOUSE EMPREENDIMENTO IMOBILIÁRIO S.A.',
         cabecalho: ', sociedade anônima inscrita no CNPJ/MF sob nº 28.131.713/0001-03, com sede na Avenida Rebouças, nº 3.084, 4° andar, parte, Pinheiros, São Paulo - SP, CEP 05402-600, declara receber de: '
      }
   }
} as { 
   [key: string]: {
      spe1: ReciboCabecalho,
      spe2?: ReciboCabecalho
   } 
};

export type ReciboCabecalho = {
   razaoSocial: string;
   cabecalho: string;
}